"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckEmailMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class CheckEmailMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "errors");
        const isLoading = lodash_1.default.get(result, "loading");
        const userExist = lodash_1.default.get(result, "data.checkEmail.userExist");
        const isValid = lodash_1.default.get(result, "data.checkEmail.valid");
        const SAML = lodash_1.default.get(result, "data.checkEmail.SAML");
        return {
            hasError,
            isLoading,
            userExist,
            isValid,
            SAML,
        };
    }
}
exports.CheckEmailMapper = CheckEmailMapper;
